module.exports = __webpack_public_path__ + "static/media/51.2773d9c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/51.wav
// module id = cHmA
// module chunks = 0